/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import Hls from "../../libs/dist-hls/hls";

export type QualityLevel = {
  height: number;
  width: number;
  bitrate: number;
  name?: string;
};

export const useHls = (videoUrl: string, time_code: number | null) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [qualities, setQualities] = useState<QualityLevel[]>([]);
  const [currentQuality, setCurrentQuality] = useState<number | "auto">("auto");
  const [loading, setLoading] = useState(false);
  const hlsRef = useRef<any>(null);
  const [audioTracks, setAudioTracks] = useState<any[]>([]);
  const [currentAudioTrack, setCurrentAudioTrack] = useState<number>(0);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !videoUrl) return;

    const handleCheckBuffering = () => {
      if (video.paused && video.readyState < 3) {
        setLoading(true);
      }
    };

    const handleWaiting = () => {
      setLoading(true);
    };

    const handleStalled = () => {
      // setLoading(true);
    };

    const handleCanPlay = () => {
      setLoading(false);
    };

    const handlePlaying = () => {
      setLoading(false);
    };

    const handleSeeked = () => {
      if (video.readyState >= 3) {
        setLoading(false);
      }
    };

    video.addEventListener("waiting", handleWaiting);
    video.addEventListener("stalled", handleStalled);
    video.addEventListener("canplay", handleCanPlay);
    video.addEventListener("playing", handlePlaying);
    video.addEventListener("seeked", handleSeeked);
    video.addEventListener("pause", handleCheckBuffering);

    if (Hls.isSupported()) {
      const hls = new Hls();
      hlsRef.current = hls;

      hls.loadSource(videoUrl);
      hls.attachMedia(video);
      hls.audioTrack = 1;

      hls.on(Hls.Events.MANIFEST_PARSED, async () => {
        setAudioTracks(hls.allAudioTracks);

        const levels = hls.levels.map((level: any) => ({
          height: level.height,
          width: level.width,
          bitrate: level.bitrate,
          name: level.name || `${level.height}p`,
        }));
        setQualities(levels);

        try {
          if (!time_code) {
            await video.play();
          }
        } catch (err) {
          console.warn("Autoplay error:", err);
        }
      });

      hls.on(Hls.Events.ERROR, (data: any) => {
        console.error("HLS error:", data);
      });

      return () => {
        video.removeEventListener("waiting", handleWaiting);
        video.removeEventListener("stalled", handleStalled);
        video.removeEventListener("canplay", handleCanPlay);
        video.removeEventListener("playing", handlePlaying);
        video.removeEventListener("seeked", handleSeeked);
        video.removeEventListener("pause", handleCheckBuffering);
        hls.destroy();
      };
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = videoUrl;

      video.addEventListener("loadedmetadata", async () => {
        try {
          if (!time_code) {
            await video.play();
          }
        } catch (err) {
          console.warn("Autoplay error (native):", err);
        }
      });
    }
  }, [videoUrl]);

  const setQuality = (index: number | "auto") => {
    if (!hlsRef.current) return;
    hlsRef.current.currentLevel = index === "auto" ? -1 : index;
    setCurrentQuality(index);
  };
  const setAudioTrack = (index: number) => {
    if (!hlsRef.current) return;
    hlsRef.current.audioTrack = index;
    setCurrentAudioTrack(index);
  };

  return {
    videoRef,
    qualities,
    currentQuality,
    setQuality,
    loading,
    audioTracks,
    setAudioTrack,
    currentAudioTrack,
  };
};
